import React from "react";
import { useTranslation } from "react-i18next";
import { Space } from "antd";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import AdnPageTitle from "../common/adnPageTitle/AdnPageTitle";
import AdnTable from "../common/adnTable/AdnTable";
import AdnCard from "../common/adnCard/AdnCard";
import AdnStatus from "../common/adnStatus/AdnStatus";

const OfferTypeListForm = ({ offertypes, handleStatusChange, loading }) => {
  const { t } = useTranslation();
  const title = t("offerType.title");
  const columns = [
    {
      title: t("offerType.columns.name"),
      dataIndex: "name",
      key: "name",
      width: "50%",
    },
    {
      title: t("offerType.columns.status"),
      dataIndex: "deleted",
      key: "deleted",
      width: "40%",
      render: (text, record) => <AdnStatus deleted={record.deleted} />,
    },
    {
      title: t("offerType.columns.action"),
      key: "action",
      render: (record) => (
        <Space style={{ display: "flex", justifyContent: "center" }}>
          {record.deleted ? (
            <CheckOutlined
              style={{ color: "green" }}
              onClick={() => handleStatusChange(record.id, record.deleted)}
            />
          ) : (
            <CloseOutlined
              style={{ color: "red" }}
              onClick={() => handleStatusChange(record.id, record.deleted)}
            />
          )}
        </Space>
      ),
    },
  ];

  return (
    <>
      <AdnPageTitle title={title} />
      <AdnCard loading={loading}>
        <AdnTable
          columns={columns}
          data={offertypes}
          handleChange="id"
          totalRecords={offertypes.length}
          pagination={false}
        />
      </AdnCard>
    </>
  );
};

export default OfferTypeListForm;
